<dt-modal-content (closeClick)="discard()" [contentPadding]="false">
  <ng-template #title i18n>Globale Variablen</ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      @if (formGroup.controls.variables.length === 0) {
        <p class="empty-indicator" i18n>Keine Variablen definiert.</p>
      }
      <ng-container formArrayName="variables">
        @for (entry of formGroup.controls.variables.controls; track entry; let i = $index) {
          <div class="row" [formGroupName]="i">
            <mat-form-field>
              <mat-label i18n>Variable</mat-label>
              <input matInput formControlName="name" data-cy="variable-name" />
              <mat-icon
                matTextSuffix
                class="info-icon"
                matTooltip="Variablennamen müssen mit einem Großbuchstaben beginnen und dürfen nur alphanumerische Zeichen enthalten"
                i18n-matTooltip
                >info</mat-icon
              >
              @if (entry.controls.name.errors?.duplicates) {
                <mat-error i18n>Der Name ist mehrfach vergeben</mat-error>
              }
              @if (entry.controls.name.errors?.required) {
                <mat-error i18n>Der Name darf nicht leer sein</mat-error>
              }
              @if (entry.controls.name.errors?.pattern) {
                <mat-error i18n>Der Name hat ein ungültiges Format</mat-error>
              }
              @if (entry.controls.name.errors?.reservedName) {
                <mat-error i18n>Der Name überschneidet sich mit den Indikatorvariablen (Ind1, Ind2, etc.)</mat-error>
              }
              <mat-hint>
                @if (usedVariables.has(entry.controls.name.value)) {
                  <span i18n
                    >Die Variable wird in
                    <span class="used-in-trigger" data-cy="used-in-trigger" [dtHoverPopover]="usedInOverlayTemplate">Zielskalen</span>
                    verwendet</span
                  >

                  <ng-template #usedInOverlayTemplate>
                    <div class="used-in-popover" data-cy="used-in-popover">
                      <ul>
                        @for (objective of usedVariables.get(entry.controls.name.value); track objective) {
                          <li data-cy="used-in-objective">{{ objective.name }}</li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                } @else {
                  <span i18n>Der Name der Variable (z.&nbsp;B. Z1)</span>
                }
              </mat-hint>
            </mat-form-field>
            <mat-form-field>
              <mat-label i18n>Wert</mat-label>
              <input matInput formControlName="value" type="number" data-cy="variable-value" />
              @if (entry.controls.value.errors?.required) {
                <mat-error i18n>Der Wert darf nicht leer sein</mat-error>
              }
              <mat-hint i18n>Der Zahlenwert der Variable</mat-hint>
            </mat-form-field>
            <button
              mat-icon-button
              type="button"
              (click)="deleteVariable(i)"
              data-cy="delete-variable"
              [disabled]="entry.controls.name.disabled"
              ><mat-icon>delete</mat-icon></button
            >
          </div>
        }
      </ng-container>
    </form>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" [disabled]="formGroup.invalid || formGroup.pristine" (click)="save()" data-cy="save-variables">
      <mat-icon>save</mat-icon>
      <ng-container i18n>Speichern</ng-container>
    </button>
    <button mat-raised-button color="accent" (click)="addVariable()" data-cy="add-variable">
      <mat-icon>add</mat-icon>
      <ng-container i18n>Variable hinzufügen</ng-container>
    </button>
    <button mat-raised-button color="accent-less" (click)="discard()" i18n data-cy="discard-changes">Verwerfen</button>
  </ng-template>
</dt-modal-content>
